<template>
  <MRow :gutter="0" class="page-header">
    <MCol class="flex min-w-0 p-3" :class="{ 'px-0': !usePadding }">
      <MRow :gutter="0" class="w-full flex-no-wrap">
        <MCol
          auto-size
          class="flex"
          :class="{
            'items-center': !$scopedSlots['default'],
            'items-start': $scopedSlots['default'],
          }"
        >
          <div class="mb-0 h3-div">
            <slot name="back-button">
              <FlotoBackButton
                v-if="backLink"
                :to="backLink"
                class="text-neutral-light mx-2"
              />
            </slot>
          </div>
        </MCol>
        <MCol class="min-w-0">
          <div
            class="flex flex-1"
            :class="{
              'items-center': !$scopedSlots['default'],
              'items-start': $scopedSlots['default'],
            }"
          >
            <div class="flex flex-1 flex-col min-w-0">
              <div
                class="h3-div flex items-center mb-0 font-semibold header-section-m"
              >
                <slot name="before-title"></slot>
                <div class="flex-1 min-w-0 head-title-m">
                  <div class="inline-flex w-full items-baseline">
                    <div class="text-ellipsis">
                      <slot name="resource-name"></slot>
                      <MTooltip placement="bottomLeft">
                        <template v-slot:trigger>
                          <span>
                            {{ title }}
                          </span>
                        </template>
                        {{ title }}
                      </MTooltip>
                      <slot name="title" />
                    </div>
                    <slot name="title-append"></slot>
                  </div>
                </div>
              </div>
              <div :class="{ 'my-1': $scopedSlots['default'] }">
                <slot />
              </div>
            </div>
            <div class="flex items-center">
              <slot name="after-title"></slot>
            </div>
          </div>
        </MCol>
      </MRow>
    </MCol>
    <slot name="additional-rows" />
    <MCol v-if="useDivider" :size="12">
      <MDivider
        :class="{
          'mt-0 mb-0': isAdditionalInfoExpanded,
          ' mt-0 mb-2': !isAdditionalInfoExpanded,
        }"
      />
    </MCol>
  </MRow>
</template>

<script>
export default {
  name: 'FlotoPageHeader',
  props: {
    backLink: { type: [String, Object], default: undefined },
    title: { type: String, default: undefined },
    useDivider: { type: Boolean, default: false },
    isAdditionalInfoExpanded: { type: Boolean, default: false },
    // eslint-disable-next-line vue/no-boolean-default
    usePadding: { type: Boolean, default: true },
  },
  computed: {
    trimmedTitle() {
      if ((this.title || '').length > 100) {
        return `${this.title.substring(0, 100)}...`
      }
      return this.title
    },
  },
}
</script>
